/* ────────────── Service Data ─────────── */
export const services = [
  {
    id: 1,
    delay: "100ms",
    title: "Custom Software and Enterprise Applications",
    link: "/services/custom-software-enterprise-applications",
    description:
      "Enterprise-grade applications that streamline operations, unify data, and stay maintainable as workflows evolve.",
    features: [
      "Portals, dashboards, and internal tools",
      "CRM/ERP integrations and API connectivity",
      "RBAC, audit trails, and scalable architecture",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <path d="M3 4h18v16H3V4zm2 2v12h14V6H5z" fill="#c79528" />
        <path d="M8 9h8v2H8zm0 4h5v2H8z" fill="#c79528" />
      </svg>
    ),
  },
  {
    id: 2,
    delay: "200ms",
    title: "Workflow Automation and System Integrations",
    link: "/services/workflow-automation-system-integrations",
    description:
      "Automation workflows that remove manual handoffs, connect tools reliably, and keep operations observable and auditable.",
    features: [
      "Process mapping and workflow engineering",
      "API integrations, webhooks, sync automation",
      "Exceptions, SLAs, monitoring, and audit logs",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <path
          d="M7 7a2 2 0 114 0 2 2 0 01-4 0zm6 10a2 2 0 114 0 2 2 0 01-4 0zM7 17a2 2 0 114 0 2 2 0 01-4 0z"
          fill="#c79528"
        />
        <path
          d="M10 7h4a3 3 0 013 3v2m0 2v0a3 3 0 01-3 3h-4"
          stroke="#c79528"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M9 17h5"
          stroke="#c79528"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: 3,
    delay: "300ms",
    title: "AI Systems and Integrations",
    link: "/services/ai-systems-integrations",
    description:
      "Applied AI systems that classify, extract, and predict inside real workflows, with clear metrics and continuous monitoring.",
    features: [
      "ML/NLP for routing, extraction, and triage",
      "Predictive analytics and forecasting",
      "Deployment, monitor, human-in-loop design",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill="#c79528" />
        <path d="M9 9h6v6H9z" fill="#fff" />
      </svg>
    ),
  },
  {
    id: 4,
    delay: "250ms",
    title: "Generative AI Solutions",
    link: "/services/generative-ai-solutions",
    description:
      "Production-ready GenAI capabilities that draft, summarize, and assist users with guardrails, evaluation, and cost control.",
    features: [
      "Copilots and RAG-based assistants",
      "Content and document automation",
      "Prompt versioning, safety, and evaluation",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill="#c79528" />
        <path d="M8 12h8M12 8v8" stroke="#fff" strokeWidth="2" />
      </svg>
    ),
  },
  {
    id: 5,
    delay: "150ms",
    title: "CMS and Digital Experience Platforms",
    link: "/services/cms-digital-experience-platforms",
    description:
      "Headless and hybrid CMS solutions built for fast publishing, SEO control, and consistent multi-channel delivery.",
    features: [
      "Headless and hybrid CMS implementations",
      "Content modeling, SEO, and migrations",
      "Governance, localization, and performance",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <path d="M4 5h16v14H4V5zm2 2v10h12V7H6z" fill="#c79528" />
        <path d="M9 11h6v2H9z" fill="#c79528" />
      </svg>
    ),
  },
  {
    id: 4,
    delay: "350ms",
    title: "SaaS Product Engineering",
    link: "/services/saas-product-engineering",
    description:
      "End-to-end SaaS engineering from MVP to multi-tenant scale, designed for reliability, security, and efficient iteration.",
    features: [
      "Multi-tenant architecture and RBAC",
      "Subscriptions, billing, and entitlements",
      "Scalability, observability, cost optimization",
    ],
    iconSVG: (
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="16" fill="#c79528" />
        <path d="M7 8h10v2H7zM7 12h6v2H7z" fill="#fff" />
      </svg>
    ),
  },
];


